/**
 * Expenditure categories a keeper actually thinks in (#537), and which
 * equipment each one covers.
 *
 * The category list used to be ten overlapping words ("NewFrame", "NewBox",
 * "Equipment") followed by a second list of what was bought, so a frame was
 * asked about twice. Five groups, and "what did you buy" narrows to the one
 * chosen.
 *
 * Equipment types are the account's own list and can be added to, so the
 * mapping is by NAME and a type this file has never met is offered under
 * every group rather than hidden from the one it belongs to.
 */
export const EXPENSE_GROUPS = [
  "Hive Component",
  "Live Assets",
  "Bee Consumables",
  "Chemicals",
  "Other",
];

const WORDS = {
  "Hive Component": ["frame", "box", "super", "feeder", "excluder", "foundation", "lid", "cover", "board", "stand", "hive"],
  "Live Assets": ["queen", "nuc", "package", "colony", "swarm", "bees"],
  "Bee Consumables": ["feed", "sugar", "syrup", "patty", "pollen"],
  "Chemicals": ["treatment", "acid", "strip", "formic", "oxalic", "thymol", "chemical"],
  "Other": ["suit", "smoker", "tool", "veil", "glove", "jacket", "other"],
};

/** The group a known equipment type belongs to, or null when unknown. */
export function groupOfEquipment(name) {
  const n = String(name || "").toLowerCase();
  for (const group of EXPENSE_GROUPS) {
    if (WORDS[group].some((w) => n.includes(w))) return group;
  }
  return null;
}

/** Equipment types to offer under `group`: its own, plus any unknown ones. */
export function equipmentForGroup(types, group) {
  return types.filter((t) => {
    const g = groupOfEquipment(t.value);
    return g === null || g === group;
  });
}
